import i18n from './index';
import { getActiveLocale } from './localeUtils';
import { PRODUCT_TYPES, ORDER_STATUS_LABELS, PAYMENT_TYPE_LABELS } from '../constants';

export const translate = (key, options = {}) => i18n.t(key, options);

export const getProductTypeLabel = (type) => translate(`constants.productTypes.${type}`, {
  defaultValue: PRODUCT_TYPES[type]?.label || type
});

export const getOrderStatusLabel = (status) => translate(`constants.orderStatus.${status}`, {
  defaultValue: ORDER_STATUS_LABELS[status] || status
});

export const getPaymentTypeLabel = (type) => translate(`constants.paymentTypes.${type}`, {
  defaultValue: PAYMENT_TYPE_LABELS[type] || type
});

export const getActiveLanguage = () => i18n.language;

export const formatLocalizedNumber = (value, options = {}) => {
  const num = parseFloat(value || 0);
  return num.toLocaleString(getActiveLocale(), options);
};

export const getSearchLocale = () => (i18n.language === 'ru' ? 'ru-RU' : 'tr-TR');
